<div>
  <div class="flex flex-row flex-wrap my-3 justify-content-between align-items-center align-content-center">
    <h3 class="text-base font-medium text-800 pr-2 m-0">
      {{'UserPages.UserFridgestorages.PageTitle' | translate}}
    </h3>

    <p-button
      (onClick)="goToCreateForm()"
      icon="pi pi-plus"
      label="{{'UserPages.UserFridgestorages.NewButtonLabel' | translate}}"
      styleClass="p-button-primary"
      class="custom-text-button"/>
  </div>

  <p-table
    [loading]="loading"
    [value]="fridgestorages"
    [paginator]="true"
    [rows]="10"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="[10, 25, 50]"
    responsiveLayout="stack"
    [breakpoint]="'600px'"
    class="custom-table">
    <ng-template pTemplate="header">
        <tr>
          <th><div class="flex align-items-center">{{'UserPages.UserFridgestorages.FridgestorageTable.StorageTypeHeader' | translate}}</div></th>
          <th><div class="flex align-items-center">{{'UserPages.UserFridgestorages.FridgestorageTable.NameHeader' | translate}}</div></th>
          <!-- <th><div class="flex align-items-center">{{'UserPages.UserFridgestorages.FridgestorageTable.ContactHeader' | translate}}</div></th>
          <th><div class="flex align-items-center">{{'UserPages.UserFridgestorages.FridgestorageTable.EmailHeader' | translate}}</div></th> -->
          <th><div class="flex align-items-center">{{'UserPages.UserFridgestorages.FridgestorageTable.CityHeader' | translate}}</div></th>
          <th><div class="flex justify-content-center align-items-center">{{'UserPages.UserFridgestorages.FridgestorageTable.CountryHeader' | translate}}</div></th>
          <th></th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-fridgeStorage>
        <tr [pSelectableRow]="fridgeStorage">
          <td><div class="flex align-items-center">{{getStorageType(fridgeStorage.storageType)}}</div></td>
          <td><div class="flex align-items-center">{{fridgeStorage.name}}</div></td>
          <!-- <td><div class="flex align-items-center">{{fridgeStorage.contactName}}</div></td>
          <td><div class="flex align-items-center">{{fridgeStorage.contactEmail}}</div></td> -->
          <td><div class="flex align-items-center">{{fridgeStorage.contactCity}}</div></td>
          <td><div class="flex justify-content-center align-items-center">{{fridgeStorage.contactCountry ? (fridgeStorage.contactCountry | countryDescription) : ''}}</div></td>
          <td>
            <div class="flex justify-content-end align-items-center gap-2">
              <p-button
                icon="pi pi-pencil"
                (onClick)="goToEditForm(fridgeStorage.id)"
                pTooltip="{{'UserPages.UserFridgestorages.FridgestorageTable.EditButton' | translate}}"
                tooltipPosition="bottom"
                class="action-btn pencil-icon"/>

              <p-button
                icon="pi pi-trash"
                pTooltip="{{'UserPages.UserFridgestorages.FridgestorageTable.DeleteButton' | translate}}"
                tooltipPosition="bottom"
                styleClass="p-button-danger"
                (onClick)="onDelete(fridgeStorage)"
                class="action-btn trash-icon"/>
            </div>
          </td>
        </tr>
    </ng-template>
  </p-table>
</div>


<p-confirmDialog acceptLabel="{{'UserPages.UserFridgestorages.FridgestorageTable.YesLabel' | translate}}" rejectLabel="{{'UserPages.UserFridgestorages.FridgestorageTable.NotLabel' | translate}}" rejectButtonStyleClass="p-button-outlined" [style]="{width: '50vw'}"></p-confirmDialog>
